// Dashboard Constants
export const CHART_COLORS = [
  '#3b82f6', 
  '#10b981', 
  '#f59e0b', 
  '#8b5cf6', 
  '#ef4444', 
  '#f97316', 
  '#06b6d4', 
  '#ec4899'
];

export const CHART_GRADIENTS = {
  requests: { from: '#3b82f6', to: '#60a5fa' },
  conversations: { from: '#10b981', to: '#34d399' },
  users: { from: '#f59e0b', to: '#fbbf24' },
  channels: { from: '#8b5cf6', to: '#a78bfa' }
};

export const VIEW_MODES = {
  DAILY: 'daily' as const,
  WEEKLY: 'weekly' as const,
  MONTHLY: 'monthly' as const
};

export const CHART_HEIGHTS = {
  LARGE: 300,
  SMALL: 300,
  RESPONSIVE_MIN: 280
};

export const SAMPLE_ACTIVITIES = [
  {
    title: 'New document processed',
    description: '15 chunks extracted successfully',
    time: '2 hours ago',
    iconType: 'file',
    status: 'success',
    color: '#3b82f6'
  },
  {
    title: 'Sync completed',
    description: 'Search index updated with 45 chunks',
    time: '4 hours ago',
    iconType: 'message',
    status: 'success',
    color: '#10b981'
  },
  {
    title: 'User conversation',
    description: 'Active chat session with AI assistant',
    time: '6 hours ago',
    iconType: 'comment',
    status: 'active',
    color: '#f59e0b'
  },
  {
    title: 'System backup',
    description: 'Automated backup completed',
    time: '1 day ago',
    iconType: 'setting',
    status: 'completed',
    color: '#8b5cf6'
  }
];

export const QUICK_ACTIONS = [
  {
    title: 'Process Documents',
    subtitle: 'Upload & Extract',
    icon: 'file',
    variant: 'primary',
    href: '/process'
  },
  {
    title: 'Manage Chunks',
    subtitle: 'Review & Edit',
    icon: 'block',
    variant: 'success',
    href: '/chunks'
  },
  {
    title: 'View History',
    subtitle: 'Activity Log',
    icon: 'history',
    variant: 'warning',
    href: '/history'
  },
  {
    title: 'Knowledge Chat',
    subtitle: 'AI Assistant',
    icon: 'message',
    variant: 'purple',
    href: '/chat'
  }
];